import React from "react";

export default function StartFreeTrialButton() {
  const handleStartFreeTrialClick = () => {
    window.location.href = process.env.REACT_APP_SLACK_OAUTH_URL;
  };

  return (
    <div
      className="flex justify-center items-center cursor-pointer button-hover"
      style={{
        width: 300,
        height: 75,
        border: "2px solid #5851bc",
        borderRadius: 8,
      }}
      onClick={handleStartFreeTrialClick}
    >
      <span className="text-4xl">Start free trial</span>
    </div>
  );
}
